import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: 20,
      borderRadius: '0px',
      backgroundColor: 'white',
      border: '2px solid #EBECF4',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      minHeight: 'calc(100vh - 250px)',
      [theme.breakpoints.up('sm')]: {
        padding: 40,
        justifyContent: 'center',
        minHeight: 'none',
        borderRadius: '0px 0px 10px 10px',
      },
    },
  }),
);

export default useStyles;
